<sh-form-group
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
    [labelActionItems]="globalActionItems$ | async"
>
    <p *ngIf="isIndeterminate" class="sh-form-group__feedback">{{ "general.only-matching-values-shown" | translate }}</p>

    <!-- Merge Strategy Component-->
    <ng-content></ng-content>

    <form [formGroup]="list" [id]="profileField.DottedKey">
        <ng-container *ngFor="let currentValueFormGroup of list.controls; let i = index">
            <div *ngIf="childProfileField$ | async as childProfileField" class="sh-form-group sh-child-field-group" [style]="nestedPadding$ | async">
                <div class="sh-action-group" style="margin-bottom: 0px">
                    <div class="sh-action-group__item">
                        <label
                            ><i>{{ childDefinitionLabel$ | async }} {{ i + 1 }}</i></label
                        >
                    </div>
                    <div *ngIf="childActionItems$ | async as actionItems" class="sh-action-group__item">
                        <sh-action-item *ngFor="let actionItem of actionItems[i]" [item]="actionItem"></sh-action-item>
                    </div>
                </div>
                <med-address-field
                    *ngIf="childProfileField.FieldDefinition; else notFound"
                    [profileField]="childProfileField"
                    [control]="currentValueFormGroup"
                    [records]="[flattenedComplexListFieldRecords[i]]"
                    [isBatchEdit]="isBatchEdit"
                    [errorMsg]="currentValueFormGroup.getError('message')"
                    [autocompleteFct]="autocompleteFct"
                    [nestedIndex]="(nestedIndex$ | async)! + 1"
                >
                </med-address-field>

                <ng-template #notFound>
                    <dt class="sh-description-list__term">{{ childProfileField.DisplayLabel }}</dt>
                    <dd class="sh-description-list__details">
                        {{ "form.error.fielddefinition-not-found" | translate: { id: childProfileField.FieldDefinitionId } }}
                    </dd>
                </ng-template>
            </div>
        </ng-container>
    </form>
</sh-form-group>

<ng-template #batchMode>
    <ng-content></ng-content>
</ng-template>
